import { GlassCard } from "./glass-card"
import {
  StatCardBody,
  statCardWrapperClassName,
  type StatCardProps,
} from "@easyflow/ui-frontend/components/ui/stat-card"

export type { StatCardProps }

/**
 * StatCard del master: riusa body e wrapper-classes condivisi da ui-frontend
 * (zero duplicazione di logica/layout) ma avvolge il contenuto nella GlassCard
 * di ui-master. In questo modo il bordo deriva dall'unica sorgente master
 * (`ui-master/glass-card`, `border-border`), come KpiCard Overview e Firewall,
 * senza più override `className="border-border"` per-istanza.
 */
export function StatCard({
  variant = "default",
  className,
  ...body
}: StatCardProps) {
  return (
    <GlassCard
      variant="elevated"
      className={statCardWrapperClassName(variant, className)}
    >
      <StatCardBody variant={variant} {...body} />
    </GlassCard>
  )
}

export default StatCard
